/** @clearscore/helpers.interpolate-with-market v0.18.23: 2022-12-12 17:54 (assemble v5.5.1) **/
import { selectors } from '@clearscore/redux.market';
var interpolateWithMarket = function interpolateWithMarket(_ref) {
  var state = _ref.state,
    _ref$url = _ref.url,
    _url = _ref$url === void 0 ? '' : _ref$url,
    _ref$market = _ref.market,
    _market = _ref$market === void 0 ? null : _ref$market;
  return _url.replace(/@market@/gi, _market || selectors.getActiveMarket(state) || 'global');
};
export { interpolateWithMarket as default };